import { render, staticRenderFns } from "./tasksCanbanCard.vue?vue&type=template&id=20cc8f30&"
import script from "./tasksCanbanCard.vue?vue&type=script&lang=js&"
export * from "./tasksCanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./tasksCanbanCard.vue?vue&type=style&index=0&id=20cc8f30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports